import { useCallback, useMemo } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { useSearcher } from 'components/modules/Insurance/hooks/useSearcher';
import * as CarInstanceActions from 'store/carInstance/actions';
import * as CarInstanceConstants from 'store/carInstance/constants';
import * as CarInstanceSelectors from 'store/carInstance/selectors';
import * as CarReferenceActions from 'store/carReference';
import * as CarReferenceConstants from 'store/carReference/constants';
import * as CarReferenceSelectors from 'store/carReference/selectors';

import { useDisabledFields } from '../../hooks/useDisabledFields';

import { NAME } from './BrandSearcher.constants';

export const useBrandSearcherPresenter = () => {
  const dispatch = useDispatch();

  const { [NAME]: error } = useSelector(CarInstanceSelectors.selectErrors);
  const brands = useSelector(CarReferenceSelectors.selectBrands) ?? [];
  const brandsFetch = useSelector(CarReferenceSelectors.selectBrandsFetch);
  const { id: value } = useSelector(CarReferenceSelectors.selectSelectedBrand) ?? {};

  const { disabled: pageRestrict } = useDisabledFields();

  const data = useMemo(() => {
    return brands.reduce((acc, brand) => {
      const { name: title, ...rest } = brand ?? {};

      if (typeof title === 'string') {
        acc.push({ ...rest, title });
      }

      return acc;
    }, []);
  }, [brands]);

  const presenter = useSearcher({ data });

  const onChange = useCallback(({ [NAME]: { title } }) => {
    dispatch(
      CarInstanceActions.setCarInstance({
        [NAME]: title,
        [CarInstanceConstants.VALUE_FIELDS.MODEL]: undefined,
        [CarInstanceConstants.VALUE_FIELDS.VERSION]: undefined,
        [CarInstanceConstants.VALUE_FIELDS.YEAR]: undefined,
      })
    );
    dispatch(
      CarInstanceActions.updateErrors({
        [NAME]: '',
        [CarInstanceConstants.VALUE_FIELDS.MODEL]: '',
        [CarInstanceConstants.VALUE_FIELDS.VERSION]: '',
        [CarInstanceConstants.VALUE_FIELDS.YEAR]: '',
      })
    );
    dispatch(
      CarReferenceActions.setSelected({
        [CarReferenceConstants.SELECTED_FIELDS.MODEL]: undefined,
        [CarReferenceConstants.SELECTED_FIELDS.VERSION]: undefined,
      })
    );
  }, []);

  return { ...presenter, disabled: brandsFetch || pageRestrict, error, onChange, value };
};
